import React from 'react';
import PropTypes from 'prop-types';
import { PayloadStates } from '@lore/utils';
import MetricLoader from '@/pages/dashboard-year/MetricLoader';
import DeltaMetric from '@/pages/dashboard-year/DeltaMetric';
import useCompletedPartnerEventEvaluations from '@/features/dashboard-eval/hooks/useCompletedPartnerEventEvaluations';
import usePartnerEventEvaluations from '@/features/dashboard-eval/hooks/usePartnerEventEvaluations';
import moment from 'moment-timezone';
import ComparisonMetric from '@/pages/dashboard-year/ComparisonMetric';

CompositePartnerEventEvaluations.propTypes = {
  state: PropTypes.string,
  network: PropTypes.shape({ id: PropTypes.number }),
  schoolStart: PropTypes.string,
  schoolEnd: PropTypes.string,
  titleOnly: PropTypes.bool,
  showTotals: PropTypes.bool
};

export default function CompositePartnerEventEvaluations(props) {
  const { state, network, schoolStart, schoolEnd, titleOnly, showTotals = true } = props;

  const previousSchoolStart = titleOnly ? undefined : moment(schoolStart).subtract(1, 'year').toISOString();

  const totalEvaluations = usePartnerEventEvaluations({ state, network, schoolStart: undefined, schoolEnd });
  const previousEvaluations = usePartnerEventEvaluations({ state, network, schoolStart: previousSchoolStart, schoolEnd: schoolStart });
  const newEvaluations = usePartnerEventEvaluations({ state, network, schoolStart, schoolEnd });

  const totalEvaluationsCompleted = useCompletedPartnerEventEvaluations({ state, network, schoolStart: undefined, schoolEnd });
  const previousEvaluationsCompleted = useCompletedPartnerEventEvaluations({ state, network, schoolStart: previousSchoolStart, schoolEnd: schoolStart });
  const newEvaluationsCompleted = useCompletedPartnerEventEvaluations({ state, network, schoolStart, schoolEnd });

  if (
    totalEvaluations.state === PayloadStates.FETCHING ||
    previousEvaluations.state === PayloadStates.FETCHING ||
    newEvaluations.state === PayloadStates.FETCHING ||
    totalEvaluationsCompleted.state === PayloadStates.FETCHING ||
    previousEvaluationsCompleted.state === PayloadStates.FETCHING ||
    newEvaluationsCompleted.state === PayloadStates.FETCHING
  ) {
    return (
      <>
        {showTotals && (
          <>
            <MetricLoader
              name="Total partner event evaluations sent"
            />
            <MetricLoader
              name="Total partner event evaluations completed"
            />
          </>
        )}
        {!titleOnly && (
          <>
            <MetricLoader
              name="Partner event evaluations sent"
            />
            <MetricLoader
              name="Partner event evaluations completed"
            />
          </>
        )}
      </>
    );
  }

  return (
    <>
      {showTotals && (
        <>
          <DeltaMetric
            name="Total partner event evaluations sent"
            value={totalEvaluations.meta.totalCount}
            delta={newEvaluations.meta.totalCount}
            titleOnly={titleOnly}
          />
          <DeltaMetric
            name="Total partner event evaluations completed"
            value={totalEvaluationsCompleted.meta.totalCount}
            delta={newEvaluationsCompleted.meta.totalCount}
            titleOnly={titleOnly}
          />
        </>
      )}
      {!titleOnly && (
        <>
          <ComparisonMetric
            name="Partner event evaluations sent"
            value={newEvaluations.meta.totalCount}
            previousValue={previousEvaluations.meta.totalCount}
            titleOnly={titleOnly}
          />
          <ComparisonMetric
            name="Partner event evaluations completed"
            value={newEvaluationsCompleted.meta.totalCount}
            previousValue={previousEvaluationsCompleted.meta.totalCount}
            titleOnly={titleOnly}
          />
        </>
      )}
    </>
  );
}
